import React, { FC, ReactNode } from 'react';

import {
  TimesheetQueryProvider,
  TimesheetEditProvider,
  TimesheetSelectionProvider,
  TimesheetDataProvider,
} from './providers';

interface Props {
  children: ReactNode;
}

export const TimesheetProviders: FC<Props> = ({ children }) => {
  return (
    <TimesheetQueryProvider>
      <TimesheetDataProvider>
        <TimesheetSelectionProvider>
          <TimesheetEditProvider>{children}</TimesheetEditProvider>
        </TimesheetSelectionProvider>
      </TimesheetDataProvider>
    </TimesheetQueryProvider>
  );
};
